export default "__VITE_ASSET__d82d27a8__"